import { useSetAtom } from 'jotai';
import { panelLoadingStateAtom } from '../atoms';
import { useEffect } from 'react';

function useLoadingState({ loading }) {
  const setLoadingState = useSetAtom(panelLoadingStateAtom);
  useEffect(() => {
    setLoadingState(loading);
  }, [loading, setLoadingState]);
}

export default useLoadingState;
